






























import { Component, Prop, Vue } from 'vue-property-decorator';
import Jimg from './Jimg.vue';
import imgs from '@/util/imgs.ts';

const defaultProducts: any[] = [
  {
    ID: '1',
    PRONAME: '服装用ePTFE膜',
    SMALLPIC: imgs.gallery_chanpin1,
    href: '#',
  },
  {
    ID: '2',
    PRONAME: 'ePTFE精密过滤膜',
    SMALLPIC: imgs.gallery_chanpin2,
    href: '#',
  },
  {
    ID: '3',
    PRONAME: 'ePTFE电子透气膜',
    SMALLPIC: imgs.gallery_chanpin3,
    href: '#',
  },
  {
    ID: '4',
    PRONAME: 'ePTFE医用驻极体膜',
    SMALLPIC: imgs.gallery_chanpin4,
    href: '#',
  },
  {
    ID: '5',
    PRONAME: 'DENTIK®户外运动面料',
    SMALLPIC: imgs.gallery_chanpin5,
    href: '#',
  },
  {
    ID: '6',
    PRONAME: 'DENTIK®消防防护面料',
    SMALLPIC: imgs.gallery_chanpin6,
    href: '#',
  },
  {
    ID: '7',
    PRONAME: 'DENTIK®军警面料',
    SMALLPIC: imgs.gallery_chanpin7,
    href: '#',
  },
  {
    ID: '8',
    PRONAME: 'DENTIK®有机堆肥及垃圾干化封罩面料',
    SMALLPIC: imgs.gallery_chanpin8,
    href: '#',
  },
  {
    ID: '9',
    PRONAME: 'DENTIK®鞋类防水透气材料',
    SMALLPIC: imgs.gallery_chanpin9,
    href: '#',
  },
  {
    ID: '10',
    PRONAME: 'DENTIK®手套用防水内胆',
    SMALLPIC: imgs.gallery_chanpin10,
    href: '#',
  },
  {
    ID: '11',
    PRONAME: 'ePTFE止水条',
    SMALLPIC: imgs.gallery_chanpin11,
    href: '#',
  },
];

@Component({
  components: {
    Jimg,
  },
})
export default class Gallery extends Vue {
  /**
   * 产品对象数组，用于渲染数据，例子
   * [{title: '服装用ePTFE膜', img: '/imgs/gallery/banner1.jpg'}]
   */
  @Prop({ default: () => defaultProducts })
  private products!: any[];
}
